import {
  Component,
  Input,
  forwardRef,
  ElementRef,
  Renderer,
  AfterViewInit,
  ViewChild
} from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
import { Sysappfields } from 'fccore2';
/**
 * fc-textææ¬æ¡
 *
 * éè¿é¼ æ æé®çè¾å¥åå®¹ï¼æ¯æåºç¡çè¡¨ååçåè£ã
 *
 * éè¦ç¨æ·è¾å¥è¡¨åååå®¹æ¶ã
 *
 * æä¾ç»ååè¾å¥æ¡ï¼å¸¦æç´¢çè¾å¥æ¡ï¼è¿å¯ä»¥è¿è¡å¤§å°éæ©ã
 *
 * äºä»¶ï¼
 *
 * 1.ç¹å»äºä»¶ï¼click
 */
@Component({
  selector: 'fc-text',
  template: `
    <ng-container *ngIf="fcShowLabel==='N'" (blur)="_blur($event)">
    <div nz-row>
        <div nz-col nzSpan="23" class="fuzzy-dropdown form-explain">
            <input nz-input *ngIf="!_fcGroup&&!_search" [(ngModel)]="innerValue" [placeholder]="fcPlaceHolder" #infocus
                [disabled]="_disabled" [nzSize]="fcSize" [type]="fcType"  (focus)="_focus($event)" (blur)="_blur($event)" 
                [readonly]="_readonly" (click)="_click($event)" (ngModelChange)="valueOnChange($event)" (keyup)="keyup($event)"
                [maxlength]="_maxlen" #_textClass="ngModel" [minlength]="_minlen" />
            <nz-input-group *ngIf="_fcGroup&&!_search" [nzAddOnBefore]="fcAddOnBefore" [nzAddOnBeforeIcon]="fcAddOnBeforeIcon" 
                [nzAddOnAfter]="fcAddOnAfter" [nzAddOnAfterIcon]="fcAddOnAfterIcon" [nzPrefix]="prefixTemplate"
                [nzSuffix]="suffixTemplate" (click)="_click($event)">
                <input type="text" nz-input [(ngModel)]="innerValue" [placeholder]="fcPlaceHolder" [disabled]="_disabled" 
                    [nzSize]="fcSize" [type]="fcType"  (focus)="_focus($event)"  (blur)="_blur($event)"  [readonly]="_readonly" 
                    (ngModelChange)="valueOnChange($event)" (keyup)="keyup($event)" [maxlength]="_maxlen" #_textClass="ngModel"
                    [minlength]="_minlen" />
            </nz-input-group>

            <nz-input-group *ngIf="_search" [nzSearch]="_search" nzSize="large" [nzSuffix]="suffixButton" [nzSize]="fcSize">
                <input type="text" nz-input [(ngModel)]="innerValue" [placeholder]="fcPlaceHolder" [disabled]="_disabled"
                    [type]="fcType"  (focus)="_focus($event)" [readonly]="_readonly"  (blur)="_blur($event)"  (ngModelChange)="checkValidator($event)"
                    (keyup)="keyup($event)" [maxlength]="_maxlen" #_textClass="ngModel" [minlength]="_minlen" />
            </nz-input-group>
            <ng-template #suffixButton>
                <a *ngIf="fcSuffixIconButton!==undefined" nz-button [nzType]="fcButtonBgColor" nzSearch (click)="_click($event)">
                    <i nz-icon [iconfont]="fcSuffixIconButton"></i>
                </a>
                <a *ngIf="fcSuffixButton!==undefined" nz-button nzType="primary" [nzSize]="fcSize" nzSearch
                    (click)="_click($event)">{{fcSuffixButton}}</a>
            </ng-template>
            <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
                {{fcHelp}}
            </div>
            <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
                <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.required}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
                </div>
            </div>
            <ul class="fuzzy-dropdown-menu">
                <li *ngFor="let data of _selectData" class="fuzzy-dropdown-item" (click)="selectValue(data[fcFieldCode])">
                    <span class="fuzzy-dropdown-item-left">{{data[fcFieldCode]}}</span>
                    <span class="fuzzy-dropdown-item-right">{{data[fcLabelCode]}}&nbsp;{{data[fcValueCode]}}</span>
                </li>
            </ul>

        </div>
        <div nz-col nzSpan="1"></div>
    </div>

</ng-container>
<ng-template #prefixTemplate><i nz-icon [iconfont]="fcPrefixIcon"></i></ng-template>
<ng-template #suffixTemplate><i nz-icon [iconfont]="fcSuffixIcon"></i></ng-template>
<div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'" >
    <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
    <div nz-col [nzSpan]="valueSpan">
        <input nz-input *ngIf="!_fcGroup&&!_search" [(ngModel)]="innerValue"  [placeholder]="fcPlaceHolder" #infocus
                    [disabled]="_disabled" [nzSize]="fcSize" [type]="fcType" (blur)="_blur($event)" (focus)="_focus($event)"
                    [readonly]="_readonly" (click)="_click($event)" (ngModelChange)="valueOnChange($event)" (keyup)="keyup($event)"
                    [maxlength]="_maxlen" #_textClass="ngModel" [minlength]="_minlen" />
        <nz-input-group *ngIf="_fcGroup&&!_search" [nzAddOnBefore]="fcAddOnBefore" [nzAddOnBeforeIcon]="fcAddOnBeforeIcon"
            [nzAddOnAfter]="fcAddOnAfter" [nzAddOnAfterIcon]="fcAddOnAfterIcon" [nzPrefix]="prefixTemplate"
            [nzSuffix]="suffixTemplate" (click)="_click($event)">
            <input type="text" nz-input [(ngModel)]="innerValue" [placeholder]="fcPlaceHolder" [disabled]="_disabled"
                [nzSize]="fcSize" [type]="fcType"  (focus)="_focus($event)" (blur)="_blur($event)" [readonly]="_readonly"
                (ngModelChange)="valueOnChange($event)" (keyup)="keyup($event)" [maxlength]="_maxlen"
                #_textClass="ngModel" [minlength]="_minlen" />
        </nz-input-group>

        <nz-input-group *ngIf="_search" [nzSearch]="_search" nzSize="large" [nzSuffix]="suffixButton" [nzSize]="fcSize">
            <input type="text" nz-input  (click)="_click($event)" [(ngModel)]="innerValue" [placeholder]="fcPlaceHolder" [disabled]="_disabled"
                [type]="fcType"  (focus)="_focus($event)" [readonly]="_readonly" [id]="fcId" (blur)="_blur($event)"
                (ngModelChange)="valueOnChange($event)" (keyup)="keyup($event)" [maxlength]="_maxlen"
                #_textClass="ngModel" [minlength]="_minlen" />
        </nz-input-group>
        <ng-template #suffixButton>
            <a *ngIf="fcSuffixIconButton!==undefined" nz-button [nzType]="fcButtonBgColor" nzSearch
                (click)="_click($event)">
                <i nz-icon [iconfont]="fcSuffixIconButton"></i>
            </a>
            <a *ngIf="fcSuffixButton!==undefined" nz-button nzType="primary" [nzSize]="fcSize" nzSearch
                (click)="_click($event)">{{fcSuffixButton}}</a>
        </ng-template>
        <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
            {{fcHelp}}
        </div>
        <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
            <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                <div class="explain-tips">{{_validator.errorMessages.required}}</div>
            </div>
            <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
            </div>
            <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
            </div>
        </div>
        <ul class="fuzzy-dropdown-menu">
            <li *ngFor="let data of _selectData" class="fuzzy-dropdown-item" (click)="selectValue(data[fcFieldCode]);">
                <span class="fuzzy-dropdown-item-left">{{data[fcFieldCode]}}</span>
                <span class="fuzzy-dropdown-item-right">{{data[fcLabelCode]}}&nbsp;{{data[fcValueCode]}}</span>
            </li>
        </ul>
    </div>
</div>
    `,
  styles: [
    `
    .fuzzy-dropdown {
        position:relative;
    }
    .fuzzy-dropdown-menu{
        background-color: #fff;
        color:rgba(0, 0, 0, 0.65);
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        max-height: 250px;
        overflow: auto;
        position: absolute;
        width: 100%;
        top: calc(100% + 2px);
        left: 0px;
        z-index:100;
    }
    .fuzzy-dropdown .fuzzy-dropdown-item {
        padding: 7px 8px;
        cursor:pointer;
        font-weight:normal;
        line-height: 1.5;
        white-space: nowrap;
        display: flex;
        justify-content: space-between;
    }
    .fuzzy-dropdown .active {
        background-color: #f7f7f7;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.65);
    }
    .fuzzy-dropdown-item:hover{
        background-color: #ecf6fd;
    }
    .fuzzy-dropdown-item-left {
        align:left;
    }
    .fuzzy-dropdown-item-right {
        align:right;
    }
    .fc-readonly {
        pointer-events: none;
    }
    :host ::ng-deep .fc-readonly .ant-input{
        background: #f5f5f5;
    }
    :host ::ng-deep [readonly]{
        background: #f5f5f5;
    }
    .fc-required{
        color:red;
    }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FctextComponent),
      multi: true
    }
  ]
})
export class FctextComponent extends FcinputComponent implements AfterViewInit {
  @ViewChild('infocus', { static: false })
  infocus: any;
  // æ¯å¦è·åé»è®¤ç¦ç¹
  @Input()
  fcAutoFocus: string;
  /**  èªå¨å®æå³é­èæ³è¾å¥ */
  @Input()
  fcAutoComplete: string;
  /** åç½®æ ç­¾ */
  @Input()
  fcAddOnBefore: string;
  /** åç½®æ ç­¾æé® */
  @Input()
  fcAddOnBeforeIcon: string;
  /** åç½®æ ç­¾ */
  @Input()
  fcAddOnAfter: string;
  /** åç½®æ ç­¾æé® */
  @Input()
  fcAddOnAfterIcon: string;
  /** åé¨åç¼ */
  @Input()
  fcPrefix: string;
  /** åé¨åç¼å¾æ  */
  @Input()
  fcPrefixIcon: string;
  /** åé¨åç¼ */
  @Input()
  fcSuffix: string;
  /** åé¨åç¼å¾æ  */
  @Input()
  fcSuffixIcon: string;
  /** å¾æ æé®åç¼ */
  @Input()
  fcSuffixIconButton: string;
  /** æé®åç¼ */
  @Input()
  fcSuffixButton: string;
  /** æ¯å¦å¸¦æç´¢æé® */
  @Input()
  fcSearch: string;
  _search: boolean;
  _timeOut: boolean = false;
  /** labelå­æ®µåç§° */
  @Input()
  fcLabelCode: string;
  /** valueå­æ®µåç§° */
  @Input()
  fcValueCode: string;
  /** èæ³è¾å¥æ°æ® */
  _selectData: any[];
  /** æ¯å¦å¸¦åãåç¼ãååç½® */
  _fcGroup: boolean = false;
  /** å¸¦æç´¢æé®-æé®çèæ¯é¢è² */
  listner: any;
  @Input()
  fcButtonBgColor: string;
  constructor(
    public provider: ProvidersService,
    public ref: ElementRef,
    public renderer: Renderer
  ) {
    super(provider, 'fc-text');
    this.fcAutoFocus = 'N';
    this.fcAutoComplete = 'N';
    this._innerValue = null;
    if (this.fcType === undefined) {
      this.fcType = FCTEXTTYPE.text;
    }
    this._selectData = [];
    // window.document.addEventListener('click',(event)=>{
    //     this._blur(event);
    // })
  }
  ngOnChanges(param) {
    super.ngOnChanges(param);
  }

  ngAfterViewInit() {
    if (this.infocus && this.fcAutoFocus === 'Y') {
      this.renderer.invokeElementMethod(this.infocus.nativeElement, 'focus');
    }
  }
  _afterParentInit() {
    /** æåºæ¬çè¾å¥æ¡ */
    if (
      this.fcAddOnBefore === undefined &&
      this.fcAddOnBeforeIcon === undefined &&
      this.fcAddOnAfter === undefined &&
      this.fcAddOnAfterIcon === undefined &&
      this.fcPrefix === undefined &&
      this.fcPrefixIcon === undefined &&
      this.fcSuffix === undefined &&
      this.fcSuffixIcon === undefined
    ) {
      this._fcGroup = false;
    } else {
      /** å¸¦åãåç¼ãååç½®çè¾å¥æ¡ */
      this._fcGroup = true;
    }
    /** æ¯å¦å¸¦æç´¢æé® */
    if (this.fcSearch === 'Y') {
      this._search = true;
      /** æç´¢æé®èæ¯é¢è²åå§å */
      if (this.fcButtonBgColor === undefined) {
        this.fcButtonBgColor = 'primary';
      }
    } else {
      this._search = false;
    }
    /** æ¯å¦ç¦ç¨ */
    if (this.fcDisabled === 'Y') {
      this._disabled = true;
    } else {
      this._disabled = false;
    }
    /** æ¯å¦åªè¯» */
    if (this.fcReadonly === 'Y') {
      this._readonly = true;
    } else {
      this._readonly = false;
    }
    /** æé¿è¾å¥ */
    if (this.fcMaxlen !== undefined) {
      this._maxlen = Number(this.fcMaxlen);
    }
    /** æç­è¾å¥ */
    if (this.fcMinlen !== undefined) {
      this._minlen = Number(this.fcMinlen);
    }
    // if(this.fcOption){
    //     this._selectData = this.fcOption;
    // }
  }
  valueOnChange(innerValue: any): void {
    this._innerValue = '';
    if (innerValue !== null || innerValue !== '' || innerValue !== undefined) {
      this._innerValue = innerValue;
    }

    this.checkValidator(this._innerValue);
    this.onChangeCallback(this._innerValue);
  }
  keyup(event) {
    if (event.keyCode === 13) {
      this._selectData = [];
    } else {
      this._searchRemoteValue(event);
    }
    super._keyup(event);
  }
  _blur($event) {
    super._blur($event);
    this._selectData = [];
  }
  /** 
   * èæ³æ¥è¯¢
   * @param event äºä»¶
   */
  _searchRemoteValue(event: any) {
    if (!this.fcAutoComplete && this.fcAutoComplete === 'N') {
      return;
    }
    if (this.fcOption) {
      this._selectData = this.fcOption;
    }
    if (this.fcAppid && this.fcFieldCode) {
      if (!this._timeOut) {
        this._timeOut = true;
        if (this._innerValue === undefined || this._innerValue === null) {
          this._selectData = [];
          return;
        }
        setTimeout(() => {
          this._selectData = [];
          if (this._selectData === undefined || this._selectData.length === 0) {
            const observ = this.appService.findWithQuery(this.fcAppid, {
              PAGESIZE: 1000,
              PAGENUM: 1,
              WHERE:
                '{"' +
                this.fcFieldCode +
                '":{like:"%' +
                this._innerValue +
                '%"}}'
            });
            this.pushDestroy(
              observ.subscribe(result => {
                this._timeOut = false;
                if (result.CODE === '0') {
                  this._selectData = result.DATA;
                }
              })
            );
          } else {
            this._timeOut = false;
          }
        }, 400);
      } else {
        this._timeOut = false;
      }
    }
  }
  /**
   *
   * @param event  æåºç¹å»äºä»¶
   */
  _click(event: any) {
    super._click(event);
    this._searchRemoteValue({});
  }
  /**
   *
   * @param value åå»éååå¼
   */
  selectValue(value) {
    this._innerValue = value;
    this._selectData = [];
    this.event('selected', value);
  }
  ngOnDestroy() {
    // window.document.removeEventListener('click',()=>{});
  }
}
export const FCTEXTTYPE = {
  text: 'text',
  password: 'password',
  hidden: 'hidden',
  search: 'search'
};
export interface FctextOption {
  field: Sysappfields;
  data?: any[] /** åå®¹  */;
}
